import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 1,
  class: "flex"
}
const _hoisted_3 = { class: "w-full min-w-0" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-between mt-1 mb-2"
}
const _hoisted_5 = { class: "ml-4 flex gap-4 text-xs uppercase font-manrope tracking-widest text-gray-400" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center flex-nowrap"
}
const _hoisted_7 = { class: "h-4 w-4 mr-1.5" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "sm:flex hidden items-center flex-nowrap"
}
const _hoisted_10 = { class: "h-4 w-4 mr-1.5" }
const _hoisted_11 = { class: "flex items-center justify-between my-1.5 w-full" }
const _hoisted_12 = { class: "min-w-0 flex-1" }
const _hoisted_13 = { class: "truncate-tight min-w-0" }
const _hoisted_14 = {
  key: 1,
  class: "flex items-center overflow-x-auto overflow-y-hidden"
}
const _hoisted_15 = {
  key: 2,
  class: "text-sm text-gray-500 mt-0.5 max-w-2xl"
}
const _hoisted_16 = { class: "flex items-center gap-x-2 mr-1 shrink-0" }
const _hoisted_17 = ["onClick"]

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { CheckCircleIcon, CheckIcon, EllipsisHorizontalIcon, PencilIcon } from '@heroicons/vue/20/solid'
import _ from 'lodash'
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'

import BackLink from '@/components/BackLink.vue'
import NeueTabs from '@/components/neue/NeueTabs.vue'
import { useDropdownAnchor } from '@/composables/useDropdownAnchor'

export default {
  __name: 'SecondaryTop',
  props: [
  'text',
  'description',
  'parent',
  'saveStatus',
  'editable',
  'primaryObject',
  'secondaryObject',
  'actions',
  'sections',
  'box'
],
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const { setReference, setFloating, floatingStyles } = useDropdownAnchor({ placement: 'bottom-end' })

const editing = ref(false)
const newText = ref(null)

const store = useStore()
const hidden = ref(true)
const timeout = ref(null)

const saving = computed(() => Boolean(store.state.savingCount))

watch(saving, () => {
  clearTimeout(timeout.value)
  if (saving.value) {
    hidden.value = false
  } else {
    timeout.value = setTimeout(() => {
      hidden.value = true
    }, 5000)
  }
})

const editText = () => {
  if (!props.editable) return
  newText.value = props.text
  editing.value = true
}
const saveText = () => {
  emit('change', newText.value)
  editing.value = false
}

const scrollTo = link => {
  const el = document.getElementById('linkable-' + link)
  if (!el) return
  el.scrollIntoView({ behavior: 'smooth' })
}

const currentSection = ref(null)

const scrollSection = _.debounce(() => {
  const tab = document.getElementById('section-' + currentSection.value)
  const strip = tab?.parentElement
  if (!strip) return
  const offset = tab.getBoundingClientRect().left - strip.getBoundingClientRect().left
  strip.scrollTo({ left: strip.scrollLeft + offset, behavior: 'smooth' })
}, 200)

const listener = () => {
  currentSection.value =
    props.sections
      ?.map(x => ({
        id: x.id,
        offset: document.getElementById('linkable-' + x.id)?.getBoundingClientRect().top - 200
      }))
      .filter(x => x.offset < 0)
      .pop()?.id || props.sections?.[0].id
  scrollSection()
}

onMounted(async () => {
  await nextTick()
  if (!props.box) return
  listener()
  props.box.parentElement.addEventListener('scroll', listener)
})
onBeforeUnmount(() => {
  if (!props.box) return
  props.box.parentElement.removeEventListener('scroll', listener)
})

return (_ctx, _cache) => {
  const _component_BasicSpinner = _resolveComponent("BasicSpinner")
  const _component_router_link = _resolveComponent("router-link")
  const _component_InputField = _resolveComponent("InputField")
  const _component_NeueButton = _resolveComponent("NeueButton")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.saveStatus)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([hidden.value && 'opacity-0', "h-8 flex items-center transition-opacity duration-200 bg-white border rounded-full pl-2 pr-3 fixed xl:left-3 xl:right-auto xl:top-2.5 right-3 top-3.5"])
        }, [
          (saving.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_BasicSpinner, {
                  size: "small",
                  color: "gray-900"
                }),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ml-1.5" }, "Saving...", -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(CheckCircleIcon), {
                  class: "w-5 h-5",
                  "aria-hidden": "true"
                }),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ml-1.5" }, "Saved all changes", -1))
              ]))
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (props.parent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(BackLink, {
              parent: props.parent
            }, null, 8, ["parent"]),
            _createElementVNode("div", _hoisted_5, [
              (props.secondaryObject)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(props.secondaryObject.icon)))
                    ]),
                    (props.secondaryObject.link)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: props.secondaryObject.link,
                          class: "hover:underline hover:text-gray-600"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.secondaryObject.name), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(props.secondaryObject.name), 1))
                  ]))
                : _createCommentVNode("", true),
              (props.primaryObject)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(props.primaryObject.icon)))
                    ]),
                    _createElementVNode("span", null, _toDisplayString(props.primaryObject.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (!editing.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["font-bold text-gray-700 text-2xl tracking-tighter flex items-center min-w-0", props.editable && 'cursor-pointer']),
                onClick: editText
              }, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(props.text), 1),
                (props.editable)
                  ? (_openBlock(), _createBlock(_unref(PencilIcon), {
                      key: 0,
                      class: "inline ml-2 w-5 h-5 shrink-0"
                    }))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "titleRight")
              ], 2))
            : _createCommentVNode("", true),
          (editing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_InputField, {
                  modelValue: newText.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((newText).value = $event)),
                  class: "font-semibold",
                  autofocus: true,
                  shrinkwrap: true,
                  onKeyup: _withKeys(saveText, ["enter"]),
                  onBlur: saveText
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(CheckIcon), {
                  class: "inline mx-2 w-6 h-6 cursor-pointer shrink-0",
                  onClick: saveText
                })
              ]))
            : _createCommentVNode("", true),
          (props.description)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(props.description), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _renderSlot(_ctx.$slots, "right"),
          (props.actions)
            ? (_openBlock(), _createBlock(_unref(Menu), {
                key: 0,
                as: "div"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(MenuButton), { ref: _unref(setReference) }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NeueButton, { type: "secondary" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(EllipsisHorizontalIcon), {
                            class: "h-5 w-5",
                            "aria-hidden": "true"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512),
                  (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createVNode(_Transition, {
                      "enter-active-class": "transition ease-out duration-100",
                      "enter-from-class": "transform opacity-0 scale-95",
                      "enter-to-class": "transform opacity-100 scale-100",
                      "leave-active-class": "transition ease-in duration-75",
                      "leave-from-class": "transform opacity-100 scale-100",
                      "leave-to-class": "transform opacity-0 scale-95"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(MenuItems), {
                          ref: _unref(setFloating),
                          style: _normalizeStyle(_unref(floatingStyles)),
                          class: "z-50 w-60 overflow-y-auto py-1 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.actions, (item) => {
                              return (_openBlock(), _createBlock(_unref(MenuItem), null, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("button", {
                                    class: _normalizeClass([[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'], "group flex items-center px-4 py-2 text-sm w-full text-left"]),
                                    onClick: item.action
                                  }, [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                      class: "mr-3 h-5 w-5 text-gray-700 group-hover:text-gray-900",
                                      "aria-hidden": "true"
                                    })),
                                    _createTextVNode(" " + _toDisplayString(item.name), 1)
                                  ], 10, _hoisted_17)
                                ]),
                                _: 2
                              }, 1024))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    })
                  ]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(NeueTabs, {
        "data-tour": "page-tabs",
        tabs: props.sections ?? [],
        "model-value": currentSection.value,
        "onUpdate:modelValue": scrollTo
      }, null, 8, ["tabs", "model-value"])
    ])
  ], 64))
}
}

}